import { DateTime } from 'luxon';

export function formatMoney(
  value: number | string,
  currency: string = 'PEN',
  locale: string = 'es-PE',
): string {
  const n = typeof value === 'string' ? Number(value) : value;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(n);
}

export function formatDate(
  value: string | Date,
  timezone: string = 'America/Lima',
  format: 'short' | 'long' | 'datetime' = 'short',
): string {
  const dt =
    typeof value === 'string' ? DateTime.fromISO(value) : DateTime.fromJSDate(value);
  const zoned = dt.setZone(timezone);
  switch (format) {
    case 'short':
      return zoned.toFormat('dd/MM/yyyy');
    case 'long':
      return zoned.toFormat("dd 'de' LLLL 'de' yyyy", { locale: 'es' });
    case 'datetime':
      return zoned.toFormat('dd/MM/yyyy HH:mm');
  }
}

export function formatDocumentNumber(series: string, number: number | string): string {
  const n = String(number).padStart(8, '0');
  return `${series}-${n}`;
}
